import * as React from 'react'
import * as localeData from 'react-intl/locale-data/en'
import * as messages from '../translations/en.json'
import { addLocaleData } from 'react-intl'
import LayoutTemplate from '../templates/Layout'

interface Props {
  children: () => React.ReactNode
}

addLocaleData(localeData)

const enLayout = (props: Props) => <LayoutTemplate {...props} locale="en" messages={messages} />

export default enLayout



// WEBPACK FOOTER //
// ./src/layouts/en.tsx